
export const setErrors = (namespace, err, msg) => {
    return {
        type: "SET_ERRORS",
        namespace,
        payload: { err, msg },
    };
};


export const clearErrors = (namespace) => {
    return {
        type: "CLEAR_ERRORS",
        namespace,
    };
};
